import { render, staticRenderFns } from "./serveSite.vue?vue&type=template&id=6c23f228&scoped=true&"
import script from "./serveSite.vue?vue&type=script&lang=js&"
export * from "./serveSite.vue?vue&type=script&lang=js&"
import style0 from "./serveSite.vue?vue&type=style&index=0&id=6c23f228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c23f228",
  null
  
)

export default component.exports